import React from 'react'
import InfoPageLayout from './InfoPageLayout'

const InfoPage = (props) => {
  const {meta, icon, title, text} = props

  return (
    <InfoPageLayout meta={meta}>
      {icon && (
        <div className={`info-icon`}>
          {icon}
        </div>
      )}
      {title && (
        <h1 className={`brand-h1 text-center w-full`}>
          {title}
        </h1>
      )}
      {text && (
        <div className={`col-sta-cen bg-faded brd-1 round maw-col-6 pad-v-2 content-pad-h t-xl-pad-v-1`}>
          <div className={`responsive-typography maw-col-4x5`}>
            {text}
          </div>
        </div>
      )}
    </InfoPageLayout>
  )
}

export default InfoPage